<header class="site-header">
  <nav class="navbar navbar-expand-lg main-navbar">
    <div class="container-fluid px-3 px-lg-4">
      <a class="navbar-brand d-flex align-items-center gap-2" routerLink="/">
        <img src="assets/images/logo.png" alt="UMYO Español" class="brand-logo" onerror="this.style.display='none'">
        <span class="brand-text">
          UMYO <span class="text-pink">ESPAÑOL</span>
          <small>DIRECTORY</small>
          <span class="tagline">FOR US. BY US. — POWERED BY UMYO.</span>
        </span>
      </a>

      <button class="menu-btn d-flex d-md-none navbar-toggler"
        type="button"
        (click)="isNavOpen = !isNavOpen"
        [attr.aria-expanded]="isNavOpen"
        aria-controls="navbarNav"
        aria-label="Toggle navigation"
      >
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 6h18M3 12h18M3 18h18"/>
        </svg>
      </button>

      <div class="navbar-collapse justify-content-center" id="navbarNav" [class.show]="isNavOpen">
        <ul class="navbar-nav main-nav">
          <li class="nav-item"><a class="nav-link" routerLink="/" (click)="isNavOpen = false">Home</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/directory" (click)="isNavOpen = false">Directory</a></li>
          <li class="nav-item"><a class="nav-link " routerLink="/packages" (click)="isNavOpen = false">Packages</a></li>
          <li class="nav-item"><a class="nav-link" href="/assets/creat-card/index.html" target="_self">Creat Card</a></li>
          <li class="nav-item"><a class="nav-link active" routerLink="/hardship" (click)="isNavOpen = false">Hardship Incentives</a></li>
        </ul>
      </div>

      <div class="d-none d-md-flex align-items-center gap-2">
        <div class="lang-switch">
          <button type="button" class="lang-btn" [class.active]="lang === 'en'" (click)="setLang('en')">EN</button>
          <button type="button" class="lang-btn" [class.active]="lang === 'es'" (click)="setLang('es')">ES</button>
        </div>

        <a href="/?authTab=login#login" class="btn btn-outline-pink btn-sm-pad">{{ t.nav.login }}</a>
        <a href="/?authTab=register#register" class="btn btn-pink">{{ t.nav.register }}</a>
      </div>
    </div>
  </nav>
</header>

<!-- ============ HERO ============ -->
<section class="hs-hero">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 position-relative">
        <span class="hs-eyebrow">{{ t.hero.tagline }}</span>
        <h1 class="hs-hero-title">
          {{ t.hero.title }}<br>
          <span class="text-pink">{{ t.hero.subtitle }}</span>
        </h1>
        <p class="hs-hero-subtitle">
          {{ t.hero.desc }}
        </p>
        <p class="hs-hero-subtitle strong">
          {{ t.hero.pledge }}
        </p>
        <div class="hs-hero-tags">
          <span *ngFor="let tag of t.hero.tags; let i = index">
            {{ tag }}<span class="hs-dot" *ngIf="i < t.hero.tags.length - 1">•</span>
          </span>
        </div>
      </div>

      <div class="col-lg-6">
      </div>
    </div>

    <!-- PLEDGE BANNER -->
    <div class="hs-pledge">
      <div class="hs-pledge-icon">
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      </div>

      <div class="hs-pledge-stat">
        <span>{{ t.pledge.label }}</span>
        <h2>{{ t.pledge.percent }}</h2>
        <span>{{ t.pledge.suffix }}</span>
      </div>

      <div class="hs-pledge-divider"></div>

      <p class="hs-pledge-text">
        {{ t.pledge.text }}
      </p>
    </div>
  </div>
</section>

<!-- ============ HARDSHIP INCENTIVES GRID ============ -->
<section class="hs-incentives-section">
  <div class="container">
    <h2 class="hs-section-title">
      <span class="hs-rule"></span>
      {{ t.incentives.title }}
      <span class="hs-rule"></span>
    </h2>

    <p class="hs-incentives-intro">
      {{ t.incentives.subtitle }}
    </p>

    <div class="hs-grid">
      <div class="hs-card" *ngFor="let item of incentives">
        <div class="hs-card-top">
          <div class="hs-card-icon">
            <img [src]="item.icon" [alt]="item.title" class="icon-img" onerror="this.style.display='none'">
          </div>
          <h4>{{ item.title }}</h4>
          <p>{{ item.description }}</p>
          <span class="hs-amount">{{ item.amount }}</span>
        </div>
        <div class="hs-card-photo">
          <img [src]="item.illustration" [alt]="item.title" class="hs-card-img" onerror="this.style.display='none'">
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============ HOW IT WORKS + WHEN WE GROW ============ -->
<section class="hs-how-section">
  <div class="container">
    <div class="hs-how-row">

      <div class="hs-how-card">
        <h3 class="hs-how-title">
          <span class="hs-rule-short"></span>
          {{ t.howItWorks.title }}
          <span class="hs-rule-short"></span>
        </h3>

        <div class="hs-steps">
          <div class="hs-step" *ngFor="let step of steps; let last = last">
            <div class="hs-step-icon">
              <span class="icon" [innerHTML]="safeSvg(step.icon)"></span>
            </div>
            <div class="hs-step-content">
              <h5>{{ step.number }}. {{ step.title }}</h5>
              <p>{{ step.description }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="hs-grow-card">
        <div class="hs-grow-icon">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z"/>
          </svg>
        </div>
        <h4>{{ t.grow.title }}</h4>
        <p>{{ t.grow.desc }}</p>
      </div>

    </div>
  </div>
</section>

<!-- ============ UP TO 20% BACK ============ -->
<section class="hs-back-section">
  <div class="container">
    <h2 class="hs-section-title">
      <span class="hs-rule"></span>
      {{ t.back.title }}
      <span class="hs-rule"></span>
    </h2>
    <p class="hs-back-lead">
      {{ t.back.subtitle }}
    </p>
    <p class="hs-back-text">
      {{ t.back.desc }}
    </p>
    <ul class="hs-back-list">
      <li *ngFor="let item of t.back.list">{{ item }}</li>
    </ul>
  </div>
</section>

<!-- ============ MORE WE GROW, MORE IMPACT ============ -->
<section class="hs-growth-section">
  <div class="container">
    <h2 class="hs-section-title">
      <span class="hs-rule"></span>
      {{ t.impact.title }}
      <span class="hs-rule"></span>
    </h2>

    <div class="hs-growth-grid">
      <div class="hs-growth-card" *ngFor="let item of t.impact.items">
        <h5>{{ item.title }}</h5>
        <p>{{ item.desc }}</p>
      </div>
    </div>

    <p class="hs-growth-tagline">{{ t.impact.tagline }}</p>
  </div>
</section>

<!-- ============ BUILT FOR OUR COMMUNITY ============ -->
<section class="hs-built-section">
  <div class="container">
    <div class="hs-built-card">
      <h3>{{ t.built.title }}</h3>
      <p>{{ t.built.desc }}</p>
      <p class="hs-built-emphasis text-pink">{{ t.built.emphasis }}</p>
      <p>{{ t.built.closing }}</p>
    </div>
  </div>
</section>

<!-- ============ IMPORTANT PROGRAM INFORMATION ============ -->
<section class="hs-disclaimer-section">
  <div class="container">
    <div class="hs-disclaimer-card">
      <h5>{{ t.disclaimer.title }}</h5>
      <p *ngFor="let point of t.disclaimer.points">{{ point }}</p>
      <a href="#" class="hs-disclaimer-link">{{ t.disclaimer.link }}</a>
    </div>
  </div>
</section>

<!-- ============ BOTTOM CTA BAR ============ -->
<section class="hs-cta-section">
  <div class="container">
    <p class="hs-cta-lead">{{ t.cta.lead }}</p>

    <div class="hs-cta-bar">
      <div class="hs-cta-left">
        <div class="hs-cta-icon">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
        </div>
        <div>
          <h4>{{ t.cta.title }}</h4>
          <p class="text-pink mb-0">{{ t.cta.subtitle }} {{ t.cta.cta }}</p>
        </div>
      </div>

      <a href="/?authTab=register#register" class="btn btn-pink">
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"/><path d="M2 21v-1a6 6 0 0 1 6-6h2a6 6 0 0 1 6 6v1"/><path d="M19 8v6M22 11h-6"/>
        </svg>
        {{ t.cta.button }}
      </a>
    </div>
  </div>
</section>

<!-- ============ FOOTER ============ -->
<footer class="site-footer pkg-footer">
  <div class="container-fluid px-3 px-lg-4">
    <div class="row py-5">

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <div class="d-flex align-items-center gap-2 mb-2">
          <img src="assets/images/logo.png" alt="UMYO Español" class="brand-logo" onerror="this.style.display='none'">
          <div class="brand-text">UMYO <span class="text-pink">ESPAÑOL</span></div>
        </div>
        <small class="d-block pkg-footer-muted">{{ t.footer.tagline }}</small>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">{{ t.footer.quickLinks }}</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/">Home</a></li>
          <li><a routerLink="/directory">Directory</a></li>
          <li><a routerLink="/packages">Packages</a></li>
          <li><a routerLink="/hardship">Incentives</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">{{ t.footer.resources }}</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/services">Services</a></li>
          <li><a routerLink="#">How To</a></li>
          <li><a routerLink="/hardship">Hardship Incentives</a></li>
          <li><a href="/privacy">Privacy Policy</a></li>
          <li><a href="/terms">Terms of Service</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6">
        <h6 class="pkg-footer-heading">{{ t.footer.connect }}</h6>
        <div class="social-icons justify-content-start">
          <a href="#" aria-label="Instagram">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="TikTok">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 3v11.5a3.5 3.5 0 1 1-3-3.46"/><path d="M14 3c.4 2.6 2.2 4.4 5 4.8"/>
            </svg>
          </a>
          <a href="#" aria-label="YouTube">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="5" width="20" height="14" rx="4"/><path d="M10 9l6 3-6 3V9Z" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="Facebook">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3Z"/>
            </svg>
          </a>
          <a href="#" aria-label="X">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4l16 16M20 4 4 20"/>
            </svg>
          </a>
        </div>
      </div>

    </div>

    <div class="pkg-footer-bottom text-center py-3">
      <small>{{ t.footer.copyright }}</small>
    </div>
  </div>
</footer>